<div class="flex flex-col">
  <div class="flex flex-row items-start p-5">
    <div class="flex flex-1">
      <div class="mr-4 mt-1">

        <ng-container *ngIf="popupContent?.popupIconType === 'warning';else success" >
          <mat-icon [svgIcon]="'heroicons_outline:exclamation-circle'" class="bg-yellow-500 rounded-full h-8 w-8 p-1 font-semibold text-white"></mat-icon>
        </ng-container>

        <ng-template #success >
          <mat-icon [svgIcon]="'heroicons_outline:check'" class="bg-green-600 rounded-full h-8 w-8 p-1 font-semibold text-white"></mat-icon>
        </ng-template>

      </div>
      <div class="flex flex-col flex-start">
        <h1 class="mb-2 font-bold text-3xl leading-8">{{popupContent?.title | translate}}</h1>
        <p class="text-gray-500 flex flex-1">
          {{popupContent?.description}}
        </p>
      </div>
    </div>
    <em (click)="closePopup()" class="ti ti-x text-2xl rounded-full p-2 bg-gray-100 hover:bg-gray-300"></em>
  </div>
  <div class="flex justify-end space-x-3 px-6 py-5 border-t border-gray-300">
    <button *ngIf="popupContent?.buttons?.secondaryBtn?.showIf" (click)="handleButtonClick(popupContent.buttons.secondaryBtn.displayKey)" class="popup-btn text-lg font-semibold border border-gray-300 rounded-md bg-white text-gray-600 cursor-pointer">
      <em *ngIf="popupContent?.buttons?.secondaryBtn?.icon" class="text-xl" ngClass="{{ popupContent.buttons.secondaryBtn.icon}}"></em>
      <span>
        {{popupContent?.buttons?.secondaryBtn?.displayName | translate}}
      </span>
    </button>
    <button *ngIf="popupContent?.buttons?.primaryBtn?.showIf" (click)="handleButtonClick(popupContent.buttons.primaryBtn.displayKey)" class="text-lg popup-btn font-semibold bg-primary text-white rounded-md cursor-pointer">
      <em *ngIf="popupContent?.buttons?.primaryBtn?.icon" class="text-xl font-semibold mr-2" ngClass="{{ popupContent.buttons.primaryBtn.icon}}"></em>
      <span>
        {{popupContent?.buttons?.primaryBtn?.displayName | translate}}
      </span>
    </button>
  </div>
</div>